import BaseClass from "../BaseClass.js";

/**
 * buttonState bezieht sich, auf den durch die action zu erreichenden zustand! (nicht den gegenwärtigen)
 */
export default class Message extends BaseClass {

    constructor(element) {
        super(element);

        this.customID = this.generateRandomString(10);
        this.messageID = null;
        this.readState = 0;
        this.ownMessage = false;
        this.$viewPort = null;
        this.$cancelButton = null;
        this.$purchaseButtonsContainer = null;

        let mySelf = this;

        this.scrollListener = function () {
            mySelf.sentReadConfirmation();
        }

        this.markReadListener = function (event, data) {
            if (data.id == mySelf.messageID) {
                mySelf.markRead();
            }
        }

        this.cancelPurchaseListener = function (event) {
            $(document).trigger("message:cancelpurchase", {
                id: mySelf.messageID
            });
        }

        this.init();
    }


    init() {
        let mySelf = this;
        this.messageID = this.$element.attr('data-message-id');
        this.readState = this.$element.attr('data-read-state');

        if (this.$element.attr('own') == 1) {
            this.ownMessage = true;
        }

        this.$viewPort = this.$element.parents('[data-type="conversation_viewport"]');

        let $cancelButton = this.$element.find('[data-type="cancel"]');

        if ($cancelButton != undefined) {
            this.$cancelButton = $cancelButton;
            let $purchaseButtonsContainer = this.$element.find('[data-type="purchase_buttons"]');
            if ($purchaseButtonsContainer != undefined) {
                this.$purchaseButtonsContainer = $purchaseButtonsContainer;
            }

            this.$cancelButton.on("click", this.cancelPurchaseListener);
        }

        $(document).on("content:scrolled", this.scrollListener);
        $(document).on("content:resized", this.scrollListener);
        $(document).on("message:markread", this.markReadListener);
        $(document).on("focus", function () {
            mySelf.sentReadConfirmation();
        });

        this.sentReadConfirmation();
    }

    markRead() {
        this.$element.find('[data-type="msg-received-check"]').addClass('hidden');
        this.$element.find('[data-type="msg-read-check"]').removeClass('hidden');
    }

    sentReadConfirmation() {
        let mySelf = this;
        if (this.ownMessage || this.readState == 1) {
            return;
        }

        if (document.hasFocus()) {
            if (this.isVisible(this.$viewPort, this.$element, 10, 0, 0)) {
                this.readState = 1;
                this.$element.attr('data-read-state', 1);
                setTimeout(function () {
                    $(document).trigger("message:setread", {
                        id: mySelf.messageID
                    });
                }, 500);
            }
        }
    }

    destroyListener() {
        this.$element.off('click', this.cancelPurchaseListener);
    }
}